{
  "appType": "standalone",
  "assetsUrl": "https://app.twipla.com/",
  "standaloneBaseUrl": "https://app.twipla.com/",
  "translationsUrl": "https://cdn.twipla.com/translations/dashboard",
  "announcementModalApiUrl": "https://www.twipla.com/api/v1/inapp/bubbles/index.php",
  "announcementBannerApiUrl": "https://www.twipla.com/api/v1/inapp/banners/index.php",
  "dashboardTilesApiUrl": "https://www.twipla.com/api/v1/inapp/tiles/",
  "wixAppId": "13ee53b4-2343-b641-c84d-056d2e6ed2e6",
  "wixBaseUrl": "https://dashboard.va-endpoint.com/",
  "apiUrl": "https://api.twipla.com/api",
  "gatewayApiUrl": "https://api-gateway.twipla.com",
  "aiApiUrl": "https://ai.twipla.com",
  "dashboardWebsiteId": "20f1a12f-9fd2-11e8-b589-901b0edac50a",
  "defaultVoucherCode": "30DAYS_FREE_TRIAL_UNLIMITED",
  "presentationWebsiteId": "326865a9-6d58-11e8-834c-0242ac120005",
  "workerEnv": "production",
  "paddleVendorId": 122665,
  "paddleSandbox": false,
  "wixIgnoreVisitsUrl": "https://loadbalancer.visitor-analytics.io/worker-messages",
  "reCaptchaSiteKey": "6LeN9dkUAAAAAJn80caMCZcQf3LTdceByXtTeQhF",
  "statsOverviewReleaseDate": 1577836800,
  "chatwootToken": "6PKafZ6wwTAdrR3FgDUzxnq3",
  "awlChatwootToken": "mFb3owCeazTeCmxQHg7ZR6Qf",
  "env": "prod",
  "surveysUrl": "https://surveys.visitor-analytics.io",
  "firstPromoter": {
    "apiUrl": "https://firstpromoter.com/api",
    "apiKey": "0a3e774203352fe734a7475fd9ae3207",
    "wId": "2b88fc4438d32629b33e"
  },
  "competitionReleaseDate": 1596319200,
  "supportedLanguages": [
    "en",
    "de",
    "es",
    "pt",
    "it",
    "fr",
    "ro"
  ],
  "customDomain": ".visitor-analytics.io",
  "maintenancePeriods": [
    [
      "2024-12-06T03:30:00.000Z",
      "2024-12-06T05:30:00.000Z"
    ],
    [
      "2024-11-06T03:30:00.000Z",
      "2024-11-06T05:30:00.000Z"
    ]
  ],
  "flagSmithEnvironmentId": "Txqa9mNe6JWD9Lnya34BRR",
  "sentryDsn": "https://38dc1a994a42cfb9f8e479ca26a80439@sentry.visitor-analytics.io/2",
  "sentryAuthToken": "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",
  "sourceTag": "3.55.1-2"
}
